/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Host_Not_PublicInputs */

const en_site_url_error_host_not_public = /** @type {(inputs: Site_Url_Error_Host_Not_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is not a public website address.`)
};

const id_site_url_error_host_not_public = /** @type {(inputs: Site_Url_Error_Host_Not_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ini bukan alamat situs publik.`)
};

/**
* | output |
* | --- |
* | "This is not a public website address." |
*
* @param {Site_Url_Error_Host_Not_PublicInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_host_not_public = /** @type {((inputs?: Site_Url_Error_Host_Not_PublicInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Host_Not_PublicInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_host_not_public(inputs)
	return en_site_url_error_host_not_public(inputs)
});